import { gql } from '@reverbdotcom/commons/src/gql';
import React from 'react';
import VideoEmbed from '@reverbdotcom/commons/src/components/video_embed';
import { Item2Video as Data } from '@reverbdotcom/commons/src/gql/graphql';
import { size } from 'lodash';

interface IProps {
  listing: Data.Fragment;
}

export const Item2VideoFragment = gql(`
  fragment Item2Video on Listing {
    _id
    video {
      id
      youtubeVideoId
      empty
    }
    csp {
      _id
      videos {
        videoLinks {
          youtubeVideoId
        }
      }
    }
  }
`);

export function getVideoSlug(listing) {
  if (listing?.video?.youtubeVideoId) {
    return listing.video.youtubeVideoId;
  }
  if (size(listing?.csp?.videos?.videoLinks)) {
    return listing.csp.videos.videoLinks[0].youtubeVideoId;
  }
  return null;
}

export function Item2Video({ listing }: IProps) {
  const videoSlug = getVideoSlug(listing);
  if (!videoSlug) return null;

  return (
    <VideoEmbed slug={videoSlug} />
  );
}
